import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './RACFAQ.css';

const RACFAQ = () => {
  console.log('[RACFAQ] Component rendered');
  
  const [openIndex, setOpenIndex] = useState(null);
  
  const faqs = [
    {
      question: 'What is the RAC Program?',
      answer: `An asset purchase plus bilateral hire-back (bailment-style) arrangement. You purchase identified dairy animal(s) and place them under PharmWealth-managed operations under an executed hire-back agreement. Hire rent is calculated monthly based on Active Lease Days.`
    },
    {
      question: 'Is the hire rent fixed at 18%?',
      answer: `No. The program uses an indicative annualized hire rent rate up to 18% p.a. The exact schedule is in the executed hire-back agreement, and monthly hire rent payouts are prorated by Active Lease Days.`
    },
    {
      question: 'How is the monthly hire rent payout calculated?',
      answer: `Scheduled monthly hire rent is prorated by the ratio of Active Lease Days to total days in that month. Active Lease Days are applied as defined in the Program Overview above. Payment date: 10th of each month for the prior month.`
    },
    {
      question: 'What happens during the dry period?',
      answer: `Dry period is part of normal dairy lifecycle and is tracked through farm logs. Dry days are non-payable up to the 60-day Contract Year cap and reduce monthly hire rent by proration. Dry days beyond the 60-day Contract Year cap are treated as suspension days and trigger per-animal extension per the hire-back agreement.`
    },
    {
      question: 'What if the animal becomes non-performing?',
      answer: `If vet-certified unfit/non-performing, hire rent may pause per the hire-back agreement until resolution or replacement.`
    },
    {
      question: 'What if the animal dies or needs replacement?',
      answer: `Hire rent pauses. Replacement timing: within 30 working days (excluding Saturdays, Sundays, and declared government holidays) from the date of death or the date of vet certification of unfit/non-performing (whichever applies). Hire rent resumes once the replacement is onboarded per the hire-back agreement.`
    },
    {
      question: 'Does the contract extend when an animal is unavailable?',
      answer: `Yes. Extension is per animal: the end date for that animal can extend by the number of suspension days, as defined in the hire-back agreement.`
    },
    {
      question: 'Do I own the calves or milk benefits?',
      answer: `No. The owner does not own calves or production rights. PharmWealth retains milk/calf benefits and operational economics. The owner receives hire rent and any settlement/buyback as per the hire-back agreement.`
    },
    {
      question: 'When are monthly hire rent payouts made?',
      answer: `Bank transfer on the 10th day of each month for the prior month, with monthly statements.`
    },
    {
      question: 'What happens if a monthly hire rent payout is delayed?',
      answer: `There is a 30-day cure period. During the cure period, the hire-back agreement remains in force and arrears are payable. If not cured, the owner may terminate and initiate buyback/settlement as per the hire-back agreement. No extra compensation for late monthly hire rent payout.`
    },
    {
      question: 'Is the animal insured?',
      answer: `Yes, as per policy terms/exclusions and claim acceptance. Policyholder: owner. Beneficiary: PharmWealth. Documents are provided. Insurance proceeds are payable to PharmWealth as beneficiary for operational continuity (replacement), while the owner's contractual position is restored through replacement and/or buyback per the hire-back agreement.`
    },
    {
      question: 'Can I visit the farm?',
      answer: `Yes, by scheduled appointment.`
    },
    {
      question: 'What updates will I receive?',
      answer: `Daily logs/records (may include media) and monthly statements summarizing hire rent payouts and status.`
    },
    {
      question: 'Is this a bank deposit or guaranteed investment?',
      answer: `No. It is an asset purchase plus bilateral hire-back agreement. Hire rent is payable for Active Lease Days and depends on the hire-back agreement terms and operational status. Participants should review documents and seek independent advice.`
    },
    {
      question: 'What are the exit terms after 2 years?',
      answer: `After the lock-in, PharmWealth offers buyback at full contract value (as defined in the hire-back agreement), subject to hire-back agreement conditions and completion of documentation/transfer steps. Settlement timelines are defined in the hire-back agreement. Buyback requires completion of documentation and transfer/novation steps defined in the hire-back agreement; outstanding dues/adjustments (if any) may be netted off.`
    }
  ];
  
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  
  return (
    <section className="rac-faq">
      <div className="rac-faq-container">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-section-title"
        >
          FAQ
        </motion.h2>
        <div className="rac-gold-line"></div>
        
        <div className="rac-faq-list">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="rac-faq-item"
            >
              <button
                className={`rac-faq-question ${openIndex === index ? 'open' : ''}`}
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <span className="rac-faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="rac-faq-answer-wrapper"
                  >
                    <div className="rac-faq-answer">
                      {faq.answer.split('\n').map((line, i) => (
                        <p key={i} style={{ marginBottom: line.trim() ? '0.75rem' : '0' }}>
                          {line.trim() || '\u00A0'}
                        </p>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RACFAQ;


